const initTable = () => {
    const tables = document.querySelectorAll('.table-free');
    tables.forEach(table => {
        let json = table.querySelector('script')
        if (json) {
            json = JSON.parse(json.textContent)
            const desktop = document.createElement('div')
            desktop.classList.add('table-desktop')
            table.appendChild(desktop)
            const colCount = json[0] ? json[0].length : 0

            json.forEach((row, i) => {
                const rowDiv = document.createElement('div')
                if (i == 0) {
                    rowDiv.classList.add('table-head')
                } else {
                    rowDiv.classList.add('table-row')
                }
                rowDiv.classList.add(`size-${colCount}`)
                row.forEach(value => {
                    const valueDiv = document.createElement('div')
                    valueDiv.innerHTML = value
                    rowDiv.appendChild(valueDiv)
                })
                desktop.appendChild(rowDiv)
            })
        }

    })
}

export { initTable };
